import ApolloClient from './ApolloClient';

export { ApolloClient };
export default ApolloClient;
